import './scripts/animations';
import Ajax from './scripts/ajax';
import './scripts/modal';
import './scripts/events';

document.addEventListener('DOMContentLoaded', () => {
    new Ajax(document.querySelector('[data-post]'));
});